/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"

import Header from "./header"
import "normalize.css"
import "./layout.scss"
import { FaFacebookSquare, FaEnvelope } from "react-icons/fa"
import Mailto from "react-protected-mailto"

// Define component
const Layout = ({ children, selectedLink, footerFacebookLink }) => {
  // Get metadata from gatsby-config
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `)

  // Return JSX content
  return (
    <>
      <Header
        siteTitle={data.site.siteMetadata.title}
        selectedLink={selectedLink}
      />
      <main>{children}</main>
      <footer>
        <div className="footer__inside">
          <div class="footer__item">
            <span className="icon-facebook">
              <FaFacebookSquare />
            </span>
            <span className="icon-facebook-text">
              <a href={footerFacebookLink}>Follow Us!</a>
            </span>
          </div>
          <div className="footer__item">
            <span className="icon-email">
              <FaEnvelope />
            </span>
            <span className="icon-email-text">
              <Mailto email="mcneicejd@gmail.com" />
            </span>
          </div>
          <div className="footer__copyright"> © {new Date().getFullYear()}</div>
        </div>
      </footer>
    </>
  )
}

// Define propTypes for validation and error checking
Layout.propTypes = {
  children: PropTypes.node.isRequired,
  selectedLink: PropTypes.node.isRequired,
}

// Export the content
export default Layout
